// extracted by mini-css-extract-plugin
export default {"container":"AdminSubPageLayout_container__JUdCI"};